<template>
  <div class="ion-page">
    <ion-content fullscreen class="ion-padding">
      <items></items>
    </ion-content>
  </div>
</template>

<script>
import Items from "../components/Items";
import * as firebase from "firebase/app";

export default {
  name: "home",
  components: {
    Items
  },
  data() {
    return {
      info: null,
      i: 0,
      photo: ""
    };
  },
  computed: {},
  created() {},
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>
